import DebounceSelect from 'components/Select/DebounceSelect';
import { EMPTY_ARRAY } from 'constants';
import useIsMounted from 'hooks/useIsMounted';
import React, { useEffect } from 'react';
import { captureException } from 'utils/errors';
import http from 'utils/http';

function SelectAuthorizedEmail({
  value, onChange,
  fixedOptions = EMPTY_ARRAY,
  autoSelectFirst = false,
  mine = false,
  ...props
}) {
  const isMounted = useIsMounted();
  const fetchAuthorizedEmails = async (searchKey = '') => {
    let options = fixedOptions;
    try {
      const res = await http.get(`v1/organizations/{{organizationId}}/authorized-emails/${mine ? 'mine/' : ''}`, {
        params: { search: searchKey },
      });

      const emails = res.data || [];

      options = [
        ...emails.map((email) => ({
          value: email.email,
          label: email.email,
        })),
        ...fixedOptions,
      ];
    } catch (e) {
      captureException(e);
    }
    return options;
  };

  useEffect(() => {
    if (!value && autoSelectFirst) {
      (async () => {
        const options = await fetchAuthorizedEmails();
        if (isMounted.current) {
          onChange(options[0]);
        }
      })();
    }
  }, [value, isMounted, autoSelectFirst, onChange]);

  return (
    <DebounceSelect
      className="w-full"
      placeholder="Select sender email..."
      fetchOptions={fetchAuthorizedEmails}
      value={value}
      onChange={onChange}
      allowClear
      size="large"
      {...props}
    />
  );
}

export default SelectAuthorizedEmail;
